import { render, staticRenderFns } from "./ReloadPage.vue?vue&type=template&id=4c619116&"
import script from "./ReloadPage.vue?vue&type=script&lang=js&"
export * from "./ReloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports